export const publicKey = '8edab65c-e2da-4cdc-8109-7b7ebcce2df7';
